import tw from 'twin.macro';

export const Main = tw.main`w-full block bg-black z-10 min-h-screen`;
